import React from "react";
import DashboardLayout from "../dashboard/layout/DashboardLayout";
import PersonasList from "../personas/PersonasList";

export default function PersonasPage() {
  return (
    <DashboardLayout
      activeItem="Personas"
      title="Personas"
      description="Create and manage personas for testing and simulation scenarios"
    >
      <div className="h-full">
        <PersonasList className="h-full" />
      </div>
    </DashboardLayout>
  );
}